import apiClient from "@/api/client";
import type { Order, WeeklyReport } from "../types";

export interface OrderReportSettingsPayload {
  requires_weekly_reports?: boolean | null;
  report_day_of_week?: number | null;
  report_due_time?: string | null;
}

export const weeklyReportsApi = {
  list: (params?: Record<string, string>) =>
    apiClient.get<{ data: WeeklyReport[] }>("/orders/weekly-reports/", { params }).then((r) => r.data.data),

  get: (id: string) =>
    apiClient.get<{ data: WeeklyReport }>(`/orders/weekly-reports/${id}/`).then((r) => r.data.data),

  submit: (id: string, files: File[]) => {
    const fd = new FormData();
    files.forEach((f) => fd.append("files", f));
    return apiClient
      .post<{ data: WeeklyReport }>(`/orders/weekly-reports/${id}/submit/`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data.data);
  },

  accept: (id: string) =>
    apiClient.post<{ data: WeeklyReport }>(`/orders/weekly-reports/${id}/accept/`).then((r) => r.data.data),

  reject: (id: string, comment: string) =>
    apiClient.post<{ data: WeeklyReport }>(`/orders/weekly-reports/${id}/reject/`, { comment }).then((r) => r.data.data),

  markRead: (id: string) =>
    apiClient.post<{ data: WeeklyReport }>(`/orders/weekly-reports/${id}/mark-read/`).then((r) => r.data.data),

  pendingCount: () =>
    apiClient.get<{ data: { count: number } }>("/orders/weekly-reports/pending-count/").then((r) => r.data.data.count),

  unreadCount: () =>
    apiClient.get<{ data: { count: number } }>("/orders/weekly-reports/unread-count/").then((r) => r.data.data.count),

  updateOrderReportSettings: (orderId: string, data: OrderReportSettingsPayload) =>
    apiClient.patch<{ data: Order }>(`/orders/${orderId}/report-settings/`, data).then((r) => r.data.data),
};
